
const en = { 
  selectFromCloud: 'Select from Cloud',
  noFilesFound: 'No files found in cloud',
  select: 'Select',
  loadMore: 'Load More',
  registeringFile: 'Registering file...',
  fileSize: 'File Size',
  lastModified: 'Last Modified',
  encrypting: 'Encrypting...',
  ready: 'Ready',
  encryptionFailed: 'Encryption failed',
  invalidFileError: 'Invalid file type',
  loading: 'Loading',
  fileReadError: 'Failed to read file',
  invalidImageFile: 'Not a valid image file',
  invalidVideoFile: 'Not a valid video file',
  fileTypeNotAllowed: 'This file type is not allowed for security reasons',
  pleaseSelectImageFile: 'Please select an image file',
  pleaseSelectVideoFile: 'Please select a video file',
  pleaseSelectFileWithExtensions: 'Please select a file with one of these extensions: {0}',
  fileIsZipNotOffice: 'File appears to be a ZIP archive, not a valid {0} file',
  failedToValidateFile: 'Failed to validate {0} file: {1}',
  failedToValidateFileSignature: 'Failed to validate file signature',
  fileSignatureMismatch: 'File signature does not match expected file type',
  fileContentMismatch: 'File content does not match the file extension. The file may be corrupted or malicious.'
}
const he = {
  selectFromCloud: 'בחר מהענן',
  noFilesFound: 'לא נמצאו קבצים בענן',
  select: 'בחר',
  loadMore: 'טען עוד',
  registeringFile: 'מרשם קובץ...',
  fileSize: 'גודל קובץ',
  lastModified: 'תאריך שינוי אחרון',
  encrypting: 'מצפין...',
  ready: 'מוכן',
  encryptionFailed: 'הצפנה נכשלה',
  invalidFileError: 'סוג קובץ לא תקין',
  loading: 'טוען',
  fileReadError: 'נכשל בקריאת הקובץ',
  invalidImageFile: 'זהו לא קובץ תמונה תקין',
  invalidVideoFile: 'זהו לא קובץ וידאו תקין',
  fileTypeNotAllowed: 'סוג קובץ זה אינו מותר מסיבות אבטחה',
  pleaseSelectImageFile: 'אנא בחר קובץ תמונה',
  pleaseSelectVideoFile: 'אנא בחר קובץ וידאו',
  pleaseSelectFileWithExtensions: 'אנא בחר קובץ עם אחת מהסיומות הבאות: {0}',
  fileIsZipNotOffice: 'הקובץ נראה כארכיון ZIP, ולא קובץ {0} תקין',
  failedToValidateFile: 'נכשל באימות קובץ {0}: {1}',
  failedToValidateFileSignature: 'נכשל באימות חתימת הקובץ',
  fileSignatureMismatch: 'חתימת הקובץ אינה תואמת לסוג הקובץ הצפוי',
  fileContentMismatch: 'תוכן הקובץ אינו תואם לסיומת הקובץ. הקובץ עלול להיות פגום או זדוני.'
}
const heF = {
  ...he,
  "edit": "ערכי",
  "submit": "שלחי",
  "signup": "הרשמי",
  "login": "התחברי",
  "logout": "התנתקי",
  "delete": "מחקי",
  "addNew": "הוסיפי חדש",
  "approve": "אשרי",
  "decline": "דחי",
  "close": "סגרי",
  "save": "שמרי",
  "invite": "הזמיני",
  "search": "חפשי",
  "createYourFirstOne": "צרי את הראשון",
  "createNew": "צרי חדש",
  "leave": "עזבי",
  "add": "הוסיפי",
  "copy": 'העתיקי'
}

export const commonLocales = {
  en,
  he,
  heF,
  fr: {}
}